<template>
  <div class="video">
    <div class="gaokao">
      <img src="@/assets/video.png" alt="">
     </div>
     <div class="videos">
       <div class="list" v-for="(item,i) in list" :key="i">
          <div class="listimg">
            <img :src="item.imgurl" class="img01" alt="">
            <img src="../../../assets/play.png" @click="plays(item)" class="play" alt="">
          </div>
          <div class="videocon">
            {{item.title}}
          </div>
       </div>
     </div>

     <videoVue autoplay ref="videoData" />
     <div class="more" style="margin-top: 20px;" @click="shipin()">
       更多视频 >>
     </div>
  </div>
</template>

<script>
import { VideoSeet_index,VideoSeet_detail } from "@/api/gw/zonghe"
import videoVue from "@/components/video.vue"
  export default {
    components:{
      videoVue
    },
     data(){
      return{
        list:[],
        loading:false,
        object:{
          src:"",
          poster:""
        },
      }
     },
     mounted(){
       this.VideoSeet_index();
     },
     methods:{
      VideoSeet_index(){
        this.loading = true
        VideoSeet_index({
          page:1,
          limit:6,
          status:1
        }).then(res=>{
         this.list = res.data.data
        }).finally(()=>{
          this.loading = false
        })
      },
      shipin(){
        if(this.list.length>0){
          this.$refs.videoData.show(this.list[0]);
        }
      },
      plays(item){
        this.$refs.videoData.show(item);
      },
     },
  }
</script>

<style lang="scss" scoped>

.more{
    width: 100%;
    text-align: center;
    font-size: 24px;
    cursor: pointer;
    text-decoration: underline;
  }
.videocon{
  cursor: pointer;
  width:346px;
  color: #fff;
  font-size: 22px;
  white-space: nowrap; /* 防止换行 */
    overflow: hidden; /* 超出部分隐藏 */
    text-overflow: ellipsis; /* 添加省略号 */
    height: 64px;
    line-height: 64px;
}
.videos{
  width: 1250px;
  margin: 0 auto;
  margin-top: 55px;
  display: flex;
  flex-wrap: wrap;
  .list{
    .listimg{
      width: 346px;
    height: 236px;
    border-radius: 10px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .play{
      width: 60px;
      height: 60px;
      z-index: 2;
      position: absolute;
    }
    .img01{
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
    }
    width: 365px;
    height: 308px;
    background: #3EB786;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-right: 77px;
    margin-bottom: 70px;
  }
  .list:nth-child(3),.list:nth-child(6){
    margin-right: 0px;
  }
  .list:nth-child(4),.list:nth-child(5),.list:nth-child(6){
    margin-bottom: 0px;
  }
}
.video{
  width: 100%;
  height: 960px;
  background: url("../../../assets/videobg.png") no-repeat;
  background-size: 100%;
  .gaokao{
    width: 236px;
    height: 43px;
    margin: 0 auto;
    padding-top: 82px;
    img{
      width: 236px;
      height: 46px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/video.vue